import { render } from "./Register.vue?vue&type=template&id=d618c72e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d618c72e"

export default script